import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppModule } from '@/modules/core/app/constants/app.constants';

export class CatalogPageRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    // When sync is enabled, we merge Classic and New O&W nav items, and hide the Catalog nav item.
    return (
      (userSettings.isModuleAvailable(AppModule.STELLAR) ||
        userSettings.isMarketplaceCentralizedInstance) &&
      !userSettings.isModuleAvailable(AppModule.IO_TOOL_STELLAR_SYNC) &&
      super.canAccessRouteFromContext()
    );
  }
}
